<template>
  <div class="about">
    <h1>This is an about page</h1>
    <button type="button" class="btn btn-dark">Long</button>

  </div>
</template>
